import { z } from 'zod';
import { alterCodeType } from '../materials/getAlterCodeTypes';

export const alterCode = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  isFromManager: z.boolean().optional(),
  isActive: z.boolean().optional(),
  alterCodeType: alterCodeType,
  deleted: z.boolean().optional(),
  alterCodeTypeId: z.string().optional(),
});

export const getAlterCodesWithConditionsSchema = z.array(alterCode);

export type GetAlterCodesWithConditions = z.infer<typeof getAlterCodesWithConditionsSchema>;
